import * as React from 'react';
import Helmet from 'react-helmet';
import {inject, observer} from 'mobx-react';
import {styled, mq} from '../../utils';
import {margin} from 'polished';
import {Auth} from '../../models/authModel';
import {Main, Header} from '../../components/AuthLayout';
import RegistrationWizard from '../../containers/RegistrationWizard';
import CohostRegistrationForm from '../../containers/CohostRegistrationForm';
import CohostRegistrationVerificationForm from '../../containers/CohostRegistrationVerificationForm';
import {PillButton} from '../../components/Button';

interface WithInjectedProps {
  auth: Auth;
}

const PageTitleWrapper = styled('div')({
  ...margin(20, 0),
  [mq('laptop')]: {
    ...margin(25, 140, 30)
  },
  [mq('desktop')]: {
    ...margin(0, 160, 78)
  }
});

const PageTitle = styled('h1')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 38,
  marginBottom: 19,
  [mq('laptop')]: {
    fontSize: 42,
    marginBottom: 21
  },
  [mq('desktop')]: {
    fontSize: 50,
    marginBottom: 25
  }
}));

const PageSubtitle = styled('p')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 16,
  fontWeight: 300,
  color: '#7E8DA6'
}));

const LoginText = styled('div')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 16,
  color: '#1B202A',
  [mq('laptopAndUp')]: {
    marginRight: 18
  }
}));

@inject('auth')
@observer
export default class RegisterCohost extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Register to be a cohost</title>
        </Helmet>
        <Header>
          <LoginText>Already have an account?</LoginText>
          <PillButton href="/login">Login</PillButton>
        </Header>
        <Main>
          <PageTitleWrapper>
            <PageTitle>Signup</PageTitle>
            <PageSubtitle>Please enter your details below</PageSubtitle>
          </PageTitleWrapper>
          <RegistrationWizard currentStepIndex={this._withInjectedProps.auth.registration.currentStepIndex}>
            <RegistrationWizard.Step title="Enter your information">
              <CohostRegistrationForm />
            </RegistrationWizard.Step>
            <RegistrationWizard.Step title="Verify email">
              <CohostRegistrationVerificationForm />
            </RegistrationWizard.Step>
          </RegistrationWizard>
        </Main>
      </React.Fragment>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/pages/RegisterCohost/RegisterCohost.tsx